import { createContext } from 'react';

const visContext = createContext();

export default visContext;
